import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      state: PropTypes.shape({}),
    }),
  ]).isRequired,
};

const defaultProps = {
  children: null,
  className: undefined,
};

// Wrapper around router link to provide consisted interface
// Also, users do not need to be careful when passing props.
// RouterLink passes along all extra props to the anchor tag
// By wrapping we can prevent component users from doing so accidentally
export default function RouterLink({ children, className, href }) {
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}

RouterLink.propTypes = propTypes;
RouterLink.defaultProps = defaultProps;
